module.exports = __webpack_public_path__ + "static/claudeyoung-f5515262e09623211c8c3e8a811c12d0.png";